import {
  IEditorSettingsParam,
  EEditorSettingsParamType,
} from '@wix/editor-settings';

export interface DesignSettings {
  text: {
    listTitle: {
      font: IEditorSettingsParam<EEditorSettingsParamType.Font>;
      color: IEditorSettingsParam<EEditorSettingsParamType.Color>;
    };
    groupName: {
      font: IEditorSettingsParam<EEditorSettingsParamType.Font>;
      color: IEditorSettingsParam<EEditorSettingsParamType.Color>;
    };
    colorOnHover: IEditorSettingsParam<EEditorSettingsParamType.Color>;
    groupInfo: {
      font: IEditorSettingsParam<EEditorSettingsParamType.Font>;
      color: IEditorSettingsParam<EEditorSettingsParamType.Color>;
    };
  };
  button: {
    borderRadius: IEditorSettingsParam<EEditorSettingsParamType.String>;
    color: IEditorSettingsParam<EEditorSettingsParamType.Color>;
    text: {
      font: IEditorSettingsParam<EEditorSettingsParamType.Font>;
      color: IEditorSettingsParam<EEditorSettingsParamType.Color>;
    };
  };
  backgroundBorder: {
    card: {
      background: {
        color: IEditorSettingsParam<EEditorSettingsParamType.Color>;
      };
    };
    app: {
      background: {
        color: IEditorSettingsParam<EEditorSettingsParamType.Color>;
      };
    };
    border: {
      color: IEditorSettingsParam<EEditorSettingsParamType.Color>;
      width: IEditorSettingsParam<EEditorSettingsParamType.Number>;
    };
  };
}

export interface LayoutSettings {
  groupListLayout: IEditorSettingsParam<EEditorSettingsParamType.String>;
  imageRatio: IEditorSettingsParam<EEditorSettingsParamType.String>;
  headerAlignment: IEditorSettingsParam<EEditorSettingsParamType.String>;
}

export interface DisplaySettings {
  showHeaderTitle: IEditorSettingsParam<EEditorSettingsParamType.Boolean>;
  showMemberAvatars: IEditorSettingsParam<EEditorSettingsParamType.Boolean>;
  showMemberCount: IEditorSettingsParam<EEditorSettingsParamType.Boolean>;
}

export interface TextSettings {
  groupListTitle: IEditorSettingsParam<EEditorSettingsParamType.String>;
  groupMembersLabel: IEditorSettingsParam<EEditorSettingsParamType.String>;
}

export enum Alignment {
  left = 'left',
  right = 'right',
  center = 'center',
}

export enum LayoutType {
  grid = 'grid',
  list = 'list',
}

export enum ButtonType {
  rectangle = 'rectangle',
  rounded = 'rounded',
}

export enum ImageRatio {
  rectangle = 'rectangle',
  square = 'square',
}
